module.exports = __webpack_public_path__ + "img/user.e9bc1097.svg";